/**
 * Distribution Statement query keys.
 *
 * The Statement is **matter-level**, not per-distribution — it is the estate's
 * cumulative account and can be produced on demand with no round in flight — so
 * these keys hang off the matter, never off a distribution id.
 */

export const distributionStatementKeys = {
  /** Root key for every Distribution Statement query. */
  all: ['distribution-statements'] as const,

  /** The live draft account for a matter, plus whether it could be issued. */
  preview: (matterId: number) =>
    [...distributionStatementKeys.all, 'preview', matterId] as const,

  /** The matter's correction trail — every statement ever issued, newest first. */
  history: (matterId: number) =>
    [...distributionStatementKeys.all, 'history', matterId] as const,

  /** One issued statement, with the account frozen at the moment it was issued. */
  detail: (matterId: number, statementId: number) =>
    [...distributionStatementKeys.all, 'detail', matterId, statementId] as const
};
